export const getDocsDummyBankAccounts = () => ([
  { bankAccountId: 'BA001', tagId: '测试账户-001' },
  { bankAccountId: 'BA002', tagId: '测试账户-002' },
]);

